import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import LoadingButton from '@mui/lab/LoadingButton';
import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@universal-tennis/ui-shared';

import { useSelector } from 'react-redux';
import { registrationConfirmationPropTypes } from '../../../utils/proptypes';
import { formatMoney } from '../../../utils/money';

import config from '../../../config';

const FreePlayMoreRegistrationConfirmation = ({ registrationFees, onRegistrationClicked, sessionId }) => {
    const { user } = useSelector((state) => state.auth);
    const { sessionEntryFee, leagueFee, serviceFee = 0, currencySymbol, total } = registrationFees || '';
    const finalCurrencySymbol = currencySymbol ?? '$';
    const PAID_LEAGUE = 'paid_league';
    const FREE_LEAGUE = 'free-league';
    const isPaidLeague = leagueFee + sessionEntryFee > 0;
    const segmentTrackingBody = {
        league_session_id: sessionId,
        member_id: user?.id,
        order_type: isPaidLeague ? PAID_LEAGUE : FREE_LEAGUE,
        currency: finalCurrencySymbol,
        session_fee: sessionEntryFee,
        league_fee: leagueFee,
        service_fee: serviceFee,
        amount_paid: total,
        revenue: total,
    };

    useEffect(() => {
        if (window?.analytics) {
            window.analytics.track('Checkout Started', segmentTrackingBody);
        }
    }, []);

    return (
        <Box display="flex" justifyContent="space-between" flexDirection="column">
            <Box pt={2} pb={4}>
                <Box sx={{
                    borderRadius: '8px',
                    background: 'linear-gradient(45deg, rgba(0, 192, 247, 0.6) 10.72%, rgba(1, 223, 203, 0.6) 85.04%)',
                    padding: '12px 20px',
                    marginBottom: '16px',
                }}
                >
                    <Typography sx={{ mb: 2 }} category="secondary" size="medium-medium">This league session is on us!</Typography>
                    <Typography sx={{ color: '#000' }} category="secondary" size="small-book">
                        USAP Champion and Challenger members get one PlayMore league session free with their annual membership.
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                    <Typography category="secondary" size="small-book">Session Fee</Typography>
                    <Typography sx={{ textDecorationLine: 'line-through' }} category="secondary" size="small-book">{formatMoney(sessionEntryFee, finalCurrencySymbol)}</Typography>
                </Box>
                <Box mb={serviceFee > 0 ? 0 : 2} display="flex" justifyContent="space-between">
                    <Typography category="secondary" size="small-book">League Fee</Typography>
                    <Typography sx={{ textDecorationLine: 'line-through' }} category="secondary" size="small-book">{formatMoney(leagueFee, finalCurrencySymbol)}</Typography>
                </Box>
                {serviceFee > 0 && (
                    <Box mb={2} display="flex" justifyContent="space-between">
                        <Typography category="secondary" size="small-book">Service Fee</Typography>
                        <Typography sx={{ textDecorationLine: 'line-through' }} category="secondary" size="small-book">{formatMoney(serviceFee, finalCurrencySymbol)}</Typography>
                    </Box>
                )}
                <Divider />
                <Box mt={2} display="flex" justifyContent="space-between">
                    <Typography category="secondary" size="small-medium">Total</Typography>
                    <Typography category="secondary" size="small-medium">{formatMoney(0, finalCurrencySymbol)}</Typography>
                </Box>
            </Box>
            <Box sx={{ mt: 'auto' }}>
                <Typography category="secondary" size="x-small-book">
                    By registering, I agree to UTR Sports&apos;<a href={`${config.marketingAppHost}/tos`}>&nbsp;terms of service&nbsp;</a>any additional terms provided by the event organizer in the event description. I also agree to provide my contact info to the event organizer solely for the purpose of participating in this event.
                </Typography>
                <LoadingButton
                    sx={{ width: '100%', mt: 2 }}
                    type="submit"
                    variant="dark"
                    onClick={onRegistrationClicked}
                    loadingIndicator={<CircularProgress color="primary" size={20} />}
                >
                    Register
                </LoadingButton>
            </Box>
        </Box>
    );
};

FreePlayMoreRegistrationConfirmation.propTypes = {
    ...registrationConfirmationPropTypes,
};

export default FreePlayMoreRegistrationConfirmation;
